<template>
    <b-modal size="lg" v-model="itemVisible" @ok="handleOk" class="pt-8" body-class="p-2" centered header-class="p-0"
        footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
        <template #modal-title>
            <div class="title-block text-center p-2">{{ title }}</div>
        </template>
        <template #default>
            <div class="create-item-popup">
                <officer-master-items v-if="useOfficerList" :officer-master-items="officerMasterItems"
                    v-model="selectedItems" />
                <b-form ref="form" v-else @submit.stop.prevent="handleSubmit">
                    <portal to="generalItemView" :disabled="!isTask">
                        <b-row>
                            <b-col cols="12" :class="{ 'mt-3': !isTask }">
                                <label class="mb-3"><strong>{{
                                    $translate('master_item')
                                }}</strong></label>
                                <div class="create-select">
                                    <master-item-type-ahead @set-master-item="setMasterItem"
                                        @update-item-type="updateItemType" :item-type-id="itemModel.order_item_type_id
                                                " :order-type="orderModel.order_type_id"
                                        v-model="itemModel.master_item_id" :disabled="(!isNew && viewMode) ||
                                            !!itemModel.id
                                            "></master-item-type-ahead>
                                </div>
                            </b-col>

                            <b-col cols="12" class="mt-3">
                                <label class="mb-3">
                                    <strong>{{
                                        $translate('description')
                                    }}</strong>
                                </label>
                                <b-form-input id="input-description" name="input-description"
                                    :placeholder="$translate('description')" @change="complete_task()" v-model="itemModel.description" :disabled="(!isNew && viewMode) || isCompleted
                                        " />
                            </b-col>
                            <b-col class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('quantity')
                                }}</strong></label>
                                <b-form-input id="input-quantity" name="input-quantity"
                                    :placeholder="$translate('quantity')" type="number" @change="complete_task()" v-model="itemModel.quantity"
                                    :disabled="(!isNew && viewMode) || isCompleted" />
                            </b-col>
                            <b-col v-if="isOrderItem" class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('price')
                                }}</strong></label>
                                <b-form-input id="input-price" name="input-price" @change="complete_task()" :placeholder="$translate('price')"
                                    type="number" min="0.01" max="100000" v-model="itemModel.price" :disabled="(!isNew && viewMode) || isCompleted
                                        " />
                            </b-col>
                            <b-col v-if="isOrderItem" class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('tax_rate')
                                }}</strong></label>
                                <b-form-input id="input-tax_rate" name="input-tax_rate"
                                    :placeholder="$translate('tax_rate')" type="number" min="0.01" max="100000" readonly
                                    v-model="itemModel.tax_rate" :disabled="(!isNew && viewMode) || isCompleted
                                        " />
                            </b-col>
                            <b-col v-if="isOrderItem" class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('uom')
                                }}</strong></label>
                                <b-form-input id="input-uom" @change="complete_task()" name="input-uom" :placeholder="$translate('uom')" type="text"
                                    v-model="itemModel.uom" :disabled="(!isNew && viewMode) || isCompleted
                                        " />
                            </b-col>
                            <b-col cols="12" v-if="isOrderItem" class="mt-3">
                                <label class="mb-3" for="input-asset_types"><strong>{{ $translate('asset_types') }}</strong></label>
                                <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group
                                        v-model="itemModel.is_customer_or_company_asset"
                                        :options="asset_type_options"
                                        :aria-describedby="ariaDescribedby"
                                        name="radio-inline"
                                        inline
                                    ></b-form-radio-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </portal>
                    <div v-if="isTask">
                        <portal-target name="generalItemView"> </portal-target>
                        <ViewTask v-model="itemModel" class="mt-3" :master-item="masterItem"
                            :disabled="(!isNew && viewMode) || isCompleted">
                        </ViewTask>
                    </div>
                    <b-collapse v-model="locationCollapseVisible">
                        <b-row class="mt-3">
                            <b-col cols="6" :class="{
                                dd: fromBinText == warehouse_message,
                            }">
                                <label class="mb-3"><strong>{{
                                    $translate('from_bin')
                                }}</strong></label>
                                <b-form-select class="form-control" v-if="fromBinText == warehouse_message"
                                    id="input-section_from_id" v-model="itemModel.section_from_id" :options="locationSections | filterLocationOptions
                                        " :disabled="(!isNew && viewMode) || isCompleted
        ">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>{{ fromBinText }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-input v-else id="input-section_from_id" readonly
                                    :value="fromBinText"></b-form-input>
                            </b-col>
                            <b-col cols="6" :class="{ dd: toBinText == warehouse_message }">
                                <label class="mb-3"><strong>{{
                                    $translate('to_bin')
                                }}</strong></label>
                                <b-form-select v-if="toBinText == warehouse_message" class="form-control"
                                    id="input-section_to_id" :options="locationSections | filterLocationOptions
                                        " v-model="itemModel.section_to_id" :disabled="(!isNew && viewMode) || isCompleted
        ">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>{{ toBinText }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-input v-else id="input-section_to_id" readonly :value="toBinText"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-collapse>
                    <div v-if="isCustomerEntity &&
                        isOutboundFlow && itemModel.master_item_id && itemModel.is_customer_or_company_asset
                        ">

                        <view-assets class="mt-3" v-model="itemModel.assets" :master_item_id="itemModel.master_item_id" :customer_id="orderModel.customer_id" :disabled="(viewMode && !isNew) || isCompleted" @change="complete_task()"  />
                    </div>
                </b-form>
            </div>
        </template>
        <template #modal-footer="{ ok }">
            <div class="mt-3 d-flex">
                <b-button id="assign_bin_locations-btn" v-if="!useOfficerList && (x => !!x.is_order_item)(itemType)" :disabled="viewMode && !isNew"
                    @click="locationCollapseVisible = !locationCollapseVisible" variant="info" class="m-1">{{
                        $translate('assign_bin_locations') }}</b-button>
                <b-button id="view-item-cancel-btn" :disabled="submitting" variant="info" @click="itemVisible = false" class="m-1">{{ $cancelLabel()
                }}</b-button>
                <b-button id="view-item-submit-btn" v-if="!isCompleted && (!viewMode || isNew)" :disabled="submitting ||
                    (useOfficerList && selectedItems.length == 0)
                    " variant="info" class="m-1" @click="ok">{{ submitTitle }}</b-button>
            </div>
        </template>
    </b-modal>
</template>

<script lang="js">
import EventBus from "@/exports/event-bus.js";
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ViewAssets from '@/components/ViewAssets'
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'
import OfficerMasterItems from './OfficerMasterItems.vue'
import ViewTask from './ViewTask.vue'

const defaultItemModel = Object.freeze({
    id: null,
    name: '',
    order_item_type_id: null,
    master_item_id: null,
    hash: null,
    description: '',
    section_from_id: null,
    section_to_id: null,
    quantity: 0,
    uom: null,
    price: 0,
    tax_rate: 0,
    assets: [],
    task_value: null,
    task_checked: 0,
    task_notes: '',
    is_customer_or_company_asset: null, // 1 = customer asset, 2 = company asset.
})

const system_message = 'system_selected'
const warehouse_message = 'select_section'
const blackhole_message = 'none'

export default {
    name: 'orders-ViewItem',
    components: {
        ViewAssets,
        MasterItemTypeAhead,
        OfficerMasterItems,
        ViewTask,
    },
    mixins: [popupMixins, permissionsMixins],
    props: ['officer', 'orderModel'],
    data() {
        return {
            selectedItems: [],
            locationCollapseVisible: false,
            assetCollapseVisible: false,

            itemVisible: false,
            submitting: false,
            salesTax: 0,

            itemModel: {},

            //////

            system_message,
            warehouse_message,
            blackhole_message,
            masterItem: {},

            ///////////////
            reference_no: null,
            viewMode: true,
            order_type_id: null,
            asset_type_options: [
                {text: this.$translate('customer'), value: 1},
                {text: this.$translate('company'), value: 2},
            ]
        }
    },

    filters: {
        filterLocationOptions(sections) {
            return sections
                .filter(x => !x.is_officer)
                .map(s => ({
                    text: `${s?.name}, ${s.location.address1},  ${s.location.city}`,
                    value: s.id,
                }))
        },
    },

    computed: {
        fromBinText() {
            const {
                isOutboundFlow,
                isInboundFlow,
                isInternalReferenceEntity,
                isBlackholeReferenceEntity,
                isInternalEntity,
            } = this
            return (isOutboundFlow && isInternalReferenceEntity) ||
                (isInboundFlow && isInternalEntity)
                ? this.$translate(warehouse_message)
                : isOutboundFlow && isBlackholeReferenceEntity
                    ? this.$translate(blackhole_message)
                    : this.$translate(system_message)
        },
        toBinText() {
            const {
                isOutboundFlow,
                isInboundFlow,
                isInternalReferenceEntity,
                isInternalEntity,
                isBlackholeReferenceEntity,
            } = this
            return (isOutboundFlow && isInternalEntity) ||
                (isInboundFlow && isInternalReferenceEntity)
                ? this.$translate(warehouse_message)
                : isInboundFlow && isBlackholeReferenceEntity
                    ? this.$translate(blackhole_message)
                    : this.$translate(system_message)
        },
        title() {
            if (this.isNew) {
                return this.itemModel.hash
                    ? `${this.$translate('edit')} ${this.masterItem?.name || this.$translate('item')}`
                    : this.isOfficerEntity
                        ? this.$translate('select_items')
                        : this.$translate('create_item')
            } else {
                const orderItemTitle = (this.itemModel.hash
                    ? `${this.$translate('edit')} ${this.$translate('item')}`
                    : this.isOfficerEntity
                        ? this.$translate('select_items')
                        : this.$translate('create_item')) + ' ' + (this.orderType?.name + ' ' + this.reference_no)
                return orderItemTitle
            }
        },

        useOfficerList() {
            return this.isOfficerEntity && !this.itemModel.id
        },
        isNew() {
            return !(this.$route.params.id > 0)
        },
        isInboundFlow() {
            return this.flows['Inbound'] == this.transaction_type.flow
        },
        isOutboundFlow() {
            return this.flows['Outbound'] == this.transaction_type.flow
        },
        isOfficerEntity() {
            return this.entities['Officer'] == this.transaction_type.entity
        },
        isCustomerEntity() {
            return this.entities['Customer'] == this.transaction_type.entity
        },
        isVendorEntity() {
            return this.entities['Vendor'] == this.transaction_type.entity
        },
        isInternalEntity() {
            return this.entities['Internal'] == this.transaction_type.entity
        },
        isBlackholeEntity() {
            return this.entities['Black Hole'] == this.transaction_type.entity
        },
        isCustomerReferenceEntity() {
            return (
                this.entities['Customer'] ==
                this.transaction_type.reference_entity
            )
        },
        isInternalReferenceEntity() {
            return (
                this.entities['Internal'] ==
                this.transaction_type.reference_entity
            )
        },

        isBlackholeReferenceEntity() {
            return (
                this.entities['Black Hole'] ==
                this.transaction_type.reference_entity
            )
        },

        flows() {
            return this.$store.getters['transactionType/flows']
        },
        entities() {
            return this.$store.getters['transactionType/entities']
        },
        transaction_type() {
            const { orderModel, orderTypes } = this
            const order_type_id = orderModel && orderModel.order_type_id
            const type = orderTypes.find(x => x.id == order_type_id)
            return (type && type.transaction_type) || {}
        },

        officerMasterItems() {
            const parseOfficerSection = (sections, section_id) => {
                sections = sections || []
                const section = sections.find(
                    x => x.location_section_id === section_id
                )
                return section || {}
            }

            const { storedItems, masterItem } = this
            const { location_section_id } = this.officer

            console.log('officerMasterItems:', masterItem)
            const _items = (masterItem && masterItem.section_items || []).map(x => {
                const section = parseOfficerSection(
                    x.sections,
                    location_section_id
                )
                delete x.sections
                x.quantity = section.quantity_on_hand
                x.exists = storedItems.some(y => y.master_item_id == x.id)
                return x
            })

            return _items && _items.filter(x => x.quantity > 0)
        },

        order_id() {
            return this.orderId || this.$route.params.id
        },
        submitTitle() {
            console.log('this.itemModel', this.itemModel)
            return this.itemModel.hash && this.submitting
                ? this.$translate('updating_item')
                : this.itemModel.hash
                    ? this.$translate('update_item')
                    : this.submitting
                        ? this.$translate('creating_item')
                        : !this.useOfficerList ||
                            (this.useOfficerList && this.selectedItems.length == 1)
                            ? this.$translate('create_item')
                            : this.$translate('create_items')
        },

        isCompleted() {
            return !!this.orderModel.completed
        },

        storedItems() {
            return this.$store.state.orderItemStore.items
        },
        locationSections() {
            return this.$store.getters['locations/locationSections']
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        orderType() {
            const { orderTypes } = this
            if (orderTypes && orderTypes.length > 0 && this.order_type_id) {
                return orderTypes.find(x => x.id === this.order_type_id)
            }

            return null // or return a default object or value, if desired
        },
        itemType() {
            console.log("......................>>>>>>>>>>>>>>", this.itemModel)
            const { order_item_type_id } = this.itemModel
            if (!order_item_type_id)
                return {
                    is_discount: true,
                }
            else
                return (
                    this.itemTypes.find(x => order_item_type_id === x.id) || {}
                )
        },
        isTask() {
            return !!this.itemType.is_task
        },

        isOrderItem() {
            return !!this.itemType.is_order_item
        },
    },
    watch: {
        entities: function (val) {
            console.log('entities--', val)
        },
        flows: function (val) {
            console.log('flows--', val)
        },
        transaction_type: {
            handler: function (val) {
                console.log('transaction type--', val)
            },
            deep: true,
        },


        'itemModel.is_customer_or_company_asset': function(val, oldVal) {
            if(val != oldVal) {
                EventBus.$emit("set-is_customer_or_company_asset", val)
            }
        },

        'this.$store.state.masterItem': {
            handler: function (val) {
                this.masterItem = val
                console.log('masterItem', val)
            },
            deep: true,
        },
        masterItem: {
            handler: function (val) {
                if (
                    val &&
                    (this.itemModel.task_value == null ||
                        typeof this.itemModel.task_value == 'undefined')
                ) {
                    this.$set(this.itemModel, 'task_value', val.default_value)
                }
            },
            deep: true,
        },
        
    },

    created() {
        if (parseInt(this.order_id)) {
            // this.$store.dispatch('locations/fetchWarehouses')
        }
        // this.$store.dispatch('itemType/fetchAll')

    },

    methods: {
        //////////////////////
        updateItemType(evt) {
            this.$set(this.itemModel, 'order_item_type_id', evt)
            this.locationCollapseVisible = false
            this.assetCollapseVisible = false
        },
        setMasterItem(masterItem) {
            console.log('master_item',masterItem);
            this.masterItem = masterItem || {}
            this.itemModel.description = this.itemModel.hash ? this.itemModel.description : this.masterItem.description
            this.itemModel.name = this.itemModel.hash ? this.itemModel?.name : this.masterItem?.name
            this.itemModel.price = this.itemModel.hash ? this.itemModel.price : this.masterItem.selling_price
            this.itemModel.uom = this.itemModel.hash ? this.itemModel.uom : this.masterItem.uom
            this.itemModel.master_item_id = this.masterItem.id
            this.itemModel.tax_rate = this.itemModel.tax_rate
            if (!this.itemModel.hash) {
                const type = this.itemTypes.find(x => x.id == this.masterItem.order_item_type_id) || {}
                this.itemModel.tax_rate = type.tax_rate || 0
            }
            // this.itemModel.quantity = 0
        },

        showItem(item, { reference_no, order_type_id, viewMode }) {
            console.log('showItem item before', item)

            this.reference_no = reference_no;
            this.viewMode = viewMode;
            this.order_type_id = order_type_id;

            this.itemVisible = true

            if (item) {
                let {
                    id,
                    name,
                    order_item_type_id,
                    master_item_id,
                    hash,
                    description,
                    section_from_id,
                    section_to_id,
                    quantity,
                    price,
                    assets,
                    uom,
                    task_value,
                    tax_rate,
                    display_order,
                    task_checked,
                    task_notes,
                    is_customer_or_company_asset,
                    customer_completion
                } = item
                this.itemModel = {
                    ...defaultItemModel,
                    id,
                    name,
                    order_item_type_id,
                    master_item_id,
                    hash,
                    description,
                    section_from_id,
                    section_to_id,
                    quantity,
                    uom,
                    price,
                    tax_rate,
                    assets,
                    task_value,
                    display_order,
                    task_checked,
                    task_notes,
                    is_customer_or_company_asset,
                    customer_completion
                }
            } else {
                this.itemModel = {
                    ...defaultItemModel,
                }
            }
            console.log('showItem after itemModel', this.itemModel)

            //////////////////
            const section_to_id = this.itemModel.section_to_id || this.orderModel.delivery_location_section_id
            this.$set(this.itemModel, 'section_to_id', section_to_id)
            this.masterItem = this.$store.state.masterItem
        },

        handleOk(evt) {
            // Prevent modal from closing
            evt.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },

        parseItem({
            id: master_item_id,
            name,
            order_item_type_id,
            display_order,
            description,
            selling_price: price,
            quantity,
            task_value,
            task_checked,
            task_notes,
            is_customer_or_company_asset,

        }) {
            return {
                name,
                display_order,
                order_item_type_id,
                description,
                quantity,
                price,
                master_item_id,
                task_value,
                task_checked,
                task_notes,
                is_customer_or_company_asset,
            }
        },

        async handleSubmit() {
            // Exit when the form isn't valid
            try {
                this.submitting = true
                const value = parseInt(this.itemModel.task_value)
                const minValue = parseInt(this.masterItem.value_min)
                const maxValue = parseInt(this.masterItem.value_max)
                if (minValue && maxValue) {
                    if (
                        value > maxValue || value < minValue
                    ) {
                        throw new Error(`${this.$translate('val_min_max_note')} ${minValue} - ${maxValue}`)
                    }
                }
                if (minValue) {
                    if (
                        value < minValue
                    ) {
                        throw new Error(`${this.$translate('val_min_note')} ${minValue} `)
                    }
                }
                if (maxValue) {
                    if (
                        value > maxValue
                    ) {
                        throw new Error(`${this.$translate('val_max_note')} ${maxValue} `)
                    }
                }
                if (this.useOfficerList) {
                    await Promise.all(
                        this.selectedItems
                            .map(this.parseItem)
                            .map(this.mergeItem)
                    )
                } else {
                    await this.mergeItem({ ...this.itemModel })
                }
                this.itemVisible = false
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },

        async mergeItem(item) {
           
            try {
                console.log('add item', item)
                this.submitting = true

                item.price = parseFloat(item.price) || 0
                item.quantity = parseInt(item.quantity) || 0

                if (!item?.name) {
                    throw new Error(this.$translate('name_required'))
                }

                if (!item.order_item_type_id) {
                    throw new Error(this.$translate('type_required'))
                }

                if (
                    item.section_from_id &&
                    item.section_to_id &&
                    item.section_from_id === item.section_to_id
                ) {
                    throw new Error(
                        this.$translate('section_item_alert')
                    )
                }
                await this.$store.dispatch('orderItemStore/merge', item)
                this.itemVisible = false
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.submitting = false;
                this.$emit('set-deposit');
            }
        },

        complete_task(){
            if(!this.isNew && this.isTask){
                this.itemModel.task_checked = true;
            }
           
        }
    },
}
</script>
